import { useState } from "react";

const initialFormData = {
  teacher_id: "", class_stream_subject_paper_id: "", academic_year: new Date().getFullYear(),
  term_id: "", is_primary: true, start_date: "", end_date: "", is_active: true,
};

export const useSubjectAllocationForm = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [editingAllocation, setEditingAllocation] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const openForm = (allocation = null) => {
    if (allocation) {
      setEditingAllocation(allocation);
      setFormData({
        teacher_id: allocation.teacher_id || "", class_stream_subject_paper_id: allocation.class_stream_subject_paper_id || "",
        academic_year: allocation.academic_year || new Date().getFullYear(), term_id: allocation.term_id || "",
        is_primary: allocation.is_primary ?? true, start_date: allocation.start_date || "",
        end_date: allocation.end_date || "", is_active: allocation.is_active ?? true,
      });
    } else {
      setEditingAllocation(null);
      setFormData(initialFormData);
    }
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setEditingAllocation(null);
    setShowForm(false);
  };

  const updateFormData = (updates) => {
    setFormData((prev) => ({ ...prev, ...updates }));
  };

  return { formData, setFormData, editingAllocation, showForm, openForm, resetForm, updateFormData };
};
